import ErrorIcon from "@mui/icons-material/Error"

const SavingError = () => <ErrorIcon />

export { SavingError }
